import { render, staticRenderFns } from "./BucketsOverview.vue?vue&type=template&id=24f84f6c&scoped=true&"
import script from "./BucketsOverview.vue?vue&type=script&lang=js&"
export * from "./BucketsOverview.vue?vue&type=script&lang=js&"
import style0 from "./BucketsOverview.vue?vue&type=style&index=0&id=24f84f6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f84f6c",
  null
  
)

export default component.exports